/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import * as z from "zod";
import { getJsonValidator } from "./getJsonValidator";
import { getStringValidator } from "./getStringValidator";
import { getNumberValidator } from "./getNumberValidator";

export const getSchema = (setting: any) => {
  if (!setting) return z.string();

  if (setting.type === "json") {
    return getJsonValidator(setting.rules ?? []);
  } else if (
    setting.type === "string" ||
    setting.type === "secret" ||
    setting.type === "select" ||
    setting.type === "url"
  ) {
    return getStringValidator(setting.rules ?? []);
  } else if (setting.type === "number") {
    return getNumberValidator(setting.rules ?? []);
  }
  return z.string();
};
